import type { Schemas } from '@npc/api-client'

import { api } from './api'
import { call } from './errors'

export type FastDelivery = Schemas['ProjectFastDelivery']
export type FastDeliveryProduction = Schemas['FastDeliveryProductionBaseline']
export type ProjectFastDeliveries = Schemas['ProjectFastDeliveryList']
export type ProjectFastDeliveryDetail = Schemas['ProjectFastDeliveryDetail']
export type FastDeliveryTimelineEvent = Schemas['FastDeliveryTimelineEvent']
export type FastDeliveryChangeSummary = Schemas['FastDeliveryChangeSummary']

export function projectFastDeliveriesQueryKey(projectId: string) {
  return ['projects', projectId, 'fast-deliveries'] as const
}

export function projectFastDeliveryQueryKey(projectId: string, releaseId: string) {
  return [...projectFastDeliveriesQueryKey(projectId), releaseId] as const
}

export function isProjectFastDeliveryQueryKey(queryKey: readonly unknown[]): boolean {
  return (
    (queryKey.length === 3 || queryKey.length === 4) &&
    queryKey[0] === 'projects' &&
    typeof queryKey[1] === 'string' &&
    queryKey[1].length > 0 &&
    queryKey[2] === 'fast-deliveries' &&
    (queryKey.length === 3 || typeof queryKey[3] === 'string')
  )
}

export function listProjectFastDeliveries(
  projectId: string,
  cursor?: string,
): Promise<ProjectFastDeliveries> {
  const next = cursor?.trim() ?? ''
  return call('/projects/{projectId}/fast-deliveries', () =>
    api.GET('/projects/{projectId}/fast-deliveries', {
      params: {
        path: { projectId },
        query: next ? { cursor: next } : undefined,
      },
    }),
  )
}

export function getProjectFastDelivery(
  projectId: string,
  releaseId: string,
): Promise<ProjectFastDeliveryDetail> {
  return call('/projects/{projectId}/fast-deliveries/{releaseId}', () =>
    api.GET('/projects/{projectId}/fast-deliveries/{releaseId}', {
      params: { path: { projectId, releaseId } },
    }),
  )
}
